export const parseAreaList = (areas) => areas.map((area) => {
    var _a;
    return (Object.assign(Object.assign({}, area), { mostRecentlyModifiedBy: (_a = area.modifiedByEmail) !== null && _a !== void 0 ? _a : area.createdByEmail }));
});
